/* unplugin-vue-components disabled */import { render } from "./save-doc.vue?vue&type=template&id=2e97e15e&scoped=true"
import script from "./save-doc.vue?vue&type=script&lang=js"
export * from "./save-doc.vue?vue&type=script&lang=js"

import "./save-doc.vue?vue&type=style&index=0&id=2e97e15e&lang=stylus&scoped=true"
import "./save-doc.vue?vue&type=style&index=1&id=2e97e15e&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e97e15e"],['__file',"src/components/cards-v2/save-doc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e97e15e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e97e15e', __exports__)) {
    api.reload('2e97e15e', __exports__)
  }
  
  module.hot.accept("./save-doc.vue?vue&type=template&id=2e97e15e&scoped=true", () => {
    api.rerender('2e97e15e', render)
  })

}


export default __exports__